// extracted by mini-css-extract-plugin
export default {"listScopedCommand":"ListItems-module__listScopedCommand--yfPc2"};